import i18n from 'utils/i18n'
import type { AdminPriceSourcesFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationPriceSourcesFiltersCollection = () => [
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.usernameFilter),
    filterName:
      ADMIN_FILTERS_NAME.updateUserUsernameFilter satisfies AdminPriceSourcesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updateUserUsernameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.merchantFilter),
    filterName:
      ADMIN_FILTERS_NAME.merchantFilter satisfies AdminPriceSourcesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.merchantFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName: ADMIN_FILTERS_NAME.createdAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.updatedAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.updatedAtFilter satisfies AdminPriceSourcesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updatedAtFilter,
  },
]

export const adminPriceSourcesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationPriceSourcesFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'priceSources', 'priceSourcesFilters'],
  showResultsTextKey: 'filters.button.apply',
}
